import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const pendingOrderStatusesAdapter = getAdapter({ idFieldName: 'value' });

const pendingOrderStatusesSlice = createSlice({
  name: 'pendingOrderStatuses',
  initialState: pendingOrderStatusesAdapter.getInitialState(),
  reducers: {
    setPendingOrderStatuses: (state, { payload: { pendingOrderStatuses } }) => {
      pendingOrderStatusesAdapter.setAll(state, pendingOrderStatuses);
    },
  },
});

const selectors = pendingOrderStatusesAdapter.getSelectors(({ pendingOrderStatuses }) => pendingOrderStatuses);

export const getPendingOrderStatuses = (state) => selectors.selectAll(state);

export const {
  setPendingOrderStatuses,
} = pendingOrderStatusesSlice.actions;

export default pendingOrderStatusesSlice.reducer;